const bazarListEn = {
  banner: {
    title: 'Bazars',
    subtitle: 'Shop from thousands of traditional rural markets',
    breadcrumbLabel: 'Bazars',
    currentPlaceholder: 'Search food...'
  },
  filter: {
    title: 'Filter Options',
    searchPlaceholder: 'Search bazars...',
    district: 'District',
    upazilla: 'Upazila',
    size: 'Bazar Size',
    sortBy: 'Sort By',
    sortOptions: {
      name: 'Name',
      storeCount: 'Store Count',
      rating: 'Rating',
      visitors: 'Popularity'
    },
    clearShort: 'Clear',
    clearAll: 'Clear All',
    activeFilters: 'Active filters:',
    labels: {
      search: 'Search',
      district: 'District',
      upazilla: 'Upazila',
      size: 'Size'
    }
  },
  results: {
    foundSuffix: 'bazars found',
    none: 'No bazars found',
    page: 'Page'
  },
  empty: {
    title: 'No bazars matched your search',
    subtitle: 'Try different filters or clear all filters',
    clear: 'Clear All Filters'
  },
  card: {
    stores: 'Stores',
    dailyVisitors: 'Daily Visitors',
    specialties: 'Specialties:',
    details: 'Details',
    visit: 'Visit'
  },
  dialog: {
    title: 'Congratulations!',
    selected: 'Your bazar has been selected',
    instruction: 'Your current bazar is now selected. Choose a category below for what you want to buy:',
    categoryPrompt: 'What would you like to shop?',
    bottomNotePrefix: 'These products will be sourced from',
    bottomNoteSuffix: '',
    close: 'See Later'
  }
};

export default bazarListEn;


